import React, { FunctionComponent } from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"

const ARTargetOverview: FunctionComponent = () => {
  return (
    <div className="container">
      <FormInput name="name" label="Name" />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="width"
            label="Width (cm)"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
        <div className="col-6">
          <FormInput
            name="height"
            label="Height (cm)"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ARTargetOverview
